import { login, changePassword } from '../../shared/services/apiService';

// ── Login and return token + user data ───────────────────────────────────────
export const loginUser = async (username, password, company_id) => {
  const res = await login({ username, password, company_id });
  return res.data.data;
};

// ── Change password ───────────────────────────────────────────────────────────
export const updatePassword = async (currentPassword, newPassword) => {
  await changePassword({ current_password: currentPassword, new_password: newPassword });
};
